import { useCurrentInsightPage } from "@radarly/core/insight-pages/context";
import { useIsCurrentInsightPageGlobal } from "@radarly/models/insight-pages/is";
import { useGetWorkspaceById } from "./useGetWorkspaceById";
import { useWorkspaceRepository } from "./useWorkspaceRepository";

export function useCurrentWorkspace() {
  const currentIp = useCurrentInsightPage();
  const isGLobalIp = useIsCurrentInsightPageGlobal();
  const ipWorkspace = useGetWorkspaceById(currentIp?.dashboardId);
  const currentWorkspace = useWorkspaceRepository().getCurrentWorkspace();
  //if there is a contextual IP and the IP is associated with a workspace => get this workspace as context
  return !!currentIp && !isGLobalIp ? ipWorkspace : currentWorkspace;
}
